module.exports = __webpack_public_path__ + "files/fd19af532a6af9f674cc2d5185de6480.png";